import { makeStyles, tokens } from '@fluentui/react-components';

export const useLayoutStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    overflow: 'hidden',
  },
  nav: {
    flexShrink: '0',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    minWidth: '0',
    overflow: 'hidden',
  },
  header: {
    flexShrink: '0',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    overflow: 'auto',
    backgroundColor: tokens.colorNeutralBackground2,
    paddingTop: '1rem',
    paddingBottom: '1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
  },
  mainFullBleed: {
    minHeight: 0,
    overflow: 'hidden',
    padding: 0,
  },
});
